import { Modal } from "react-bootstrap";
import { useEffect, useRef } from "react";
import "../styles/css/admin-style.css"

interface PreviewEstimateModalProps {
    show: boolean;
    toggle: () => void;
    onConfirm: () => void;
    html: string | null;
    failed?: boolean;
}

const PreviewEstimateModal: React.FC<PreviewEstimateModalProps> = ({ show, toggle, onConfirm, html, failed = false }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        if (show && html && iframeRef.current) {
            const doc = iframeRef.current.contentDocument;
            if (doc) {
                doc.open();
                doc.write(html);
                doc.close();
            }
        }
    }, [show, html]);

    return (
        <Modal className={'forRealModal'} show={show} onHide={toggle} size="lg">
            <Modal.Body className={'text-center'}>
                <span className='text-link-blue icon mb-3'>
                    <i className="fa-solid fa-file-lines"></i>
                </span>
                <p className="mb-4">
                    Review the estimate before sending
                </p>
                <div style={{ border: '1px solid #eee', borderRadius: '4px', overflow: 'hidden', marginBottom: '16px' }}>
                    {html
                        ? <iframe ref={iframeRef} title="Estimate Preview"
                            style={{ width: "100%", height: "60vh", border: "none" }} />
                        : failed
                            ? <p className="p-3 text-danger">The preview could not be loaded. You can still send the estimate.</p>
                            : <p className="p-3">Loading preview...</p>
                    }
                </div>
                <div className="mb-2">
                    <button className="btn btn-outline-link-blue text-strong text-uppercase m-100" onClick={() => { onConfirm(); }}>
                        <i className="far fa-paper-plane"></i> Send Estimate
                    </button>
                </div>
                <div className="pb-2">
                    <a style={{cursor: 'pointer'}} className="m-100 text-muted" onClick={toggle}>
                        Nevermind
                    </a>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default PreviewEstimateModal;
